import ShopType from "@/enum/ShopType";
import ReAuthButton from "@/scenes/setting/Shop/ListPage/components/ReAuthButton";
import { ShopOverviewResult } from "@/services/api/order";
import { useGlobalStore } from "@/store/hooks";
import { appKeyLoginShopTypes, hideSubscriptionEndTimeShopTypes, SupplierShopTypes } from "@/utils/ShopUtils";
import React from "react";
import moment from "moment";
import { observer } from "mobx-react-lite";
import PremiumVersionIcon from "@/components/PremiumVersionIcon";
import AppVersion from "@/enum/AppVersion";

interface ShopInfoColumnProps {
    shopOverviewResult: ShopOverviewResult;
}

const hideTokenExpiredShopTypes = [
    ...appKeyLoginShopTypes,
    ...SupplierShopTypes,
    ShopType.SUNING,
    ShopType.INDEPENDENT_MANUAL,
];

/**
 * 店铺信息列
 */
const ShopInfoColumn: React.FC<ShopInfoColumnProps> = function (props) {
    const { shopOverviewResult } = props;

    const globalStore = useGlobalStore();

    const { accessTokenExpiringTime, shopId, subscriptionEndTime, pendingDeletedTime } = shopOverviewResult;

    let shopName;

    const shop = globalStore.shopMapping?.get(shopId);
    const ownShop = globalStore.shopMapping?.get(shop?.ownerShopId);
    const shopSetting = globalStore.shopSettingMapping?.get(shopId);

    shopName = shop?.name;

    const shopType = shop?.type;

    if (shop?.type === ShopType.PDD_FDS) {
        shopName = `${shopName}(拼多多代发)`;
    }

    if (shop?.type === ShopType.ALIBABA_SUPPLIER) {
        shopName = `${shopName}(阿里巴巴代发)`;
    }

    if (shop?.type === ShopType.DOUDIAN_IOP) {
        shopName = `${shopName}(抖音代发)`;
    }

    let expiredText = "";

    if (accessTokenExpiringTime === 0 && !hideTokenExpiredShopTypes.includes(shopType)) {
        expiredText = "授权已过期";
    }

    const showSubscriptionEndTime =
        subscriptionEndTime &&
        !(
            hideSubscriptionEndTimeShopTypes.includes(shopType) ||
            hideSubscriptionEndTimeShopTypes.includes(ownShop?.type)
        );

    return (
        <>
            <p>
                <span>
                    <span className="shop-name">{shopName}</span>

                    {shopSetting?.appVersion === AppVersion.PREMIUM ? <PremiumVersionIcon className="ml5" /> : null}
                </span>
            </p>

            {expiredText && (
                <p>
                    <span className="error">({expiredText})</span>
                    <span className="ml5">
                        <ReAuthButton shop={shop} />
                    </span>
                </p>
            )}

            {!pendingDeletedTime && !expiredText && showSubscriptionEndTime ? (
                <p className="small text-muted mt5">到期时间:{moment(subscriptionEndTime).format("YYYY-MM-DD")}</p>
            ) : null}

            {pendingDeletedTime && (
                <p className="mt5 error fb">
                    该店铺订购已过期，即将在{moment(pendingDeletedTime).format("YYYY-MM-DD")}后删除
                </p>
            )}
        </>
    );
};

export default observer(ShopInfoColumn);
